// extracted by mini-css-extract-plugin
module.exports = {"b502wo9":"b502wo9","default":"default","with-image":"with-image"};